/**
 * Sitecore Number field `defaultTabIndex`: 1-based (1 = first tab).
 * Missing/invalid/out-of-range values default to 1.
 * When there is only one study (or no studies), the tab index is always 1.
 */
export function parseDefaultTabIndexOneBased(
  field: { value?: number } | undefined,
  totalCount: number
): number {
  if (totalCount <= 1) return 1;
  const raw = field?.value;
  if (typeof raw !== 'number' || Number.isNaN(raw)) {
    return 1;
  }
  const n = Math.trunc(raw);
  if (n < 1 || n > totalCount) return 1;
  return n;
}
